
// 右侧详情面板的类型
export const DetailType = {
    UPLOAD: 1, // 上传
    INSPECT: 2, // 巡检
    DEVICE_STATUS: 3, // 设备状态
    SEND_TASK: 4, // 派发任务
    NOTICE: 5, // 通知
    OBJECT_DETAIL: 6, // 对象详情
}